import React from 'react';
import Sidebar from '../../components/widgets/sidebar';
import SidebarBase from './Base';

export default class SidebarSubCustomer extends SidebarBase {

  render() {
    return (
      <>
        <Sidebar.Item path="/dashboard/sensors" text="لیست سنسورها" icon="fal fa-sensor" />
        <Sidebar.Item text="گروه بندی" icon="fal fa-box">
          <Sidebar.Item path="/dashboard/groups" text="نمایش گروه ها" />
          <Sidebar.Item path="/dashboard/edit-groups" text="ویرایش گروه بندی" />
        </Sidebar.Item>
        <Sidebar.Item path="/dashboard/alarms" icon="fa-exclamation-triangle" text="هشدارها"  {...this.getBadge()} />
      </>
    );
  }

}
